export default {
  computed: {
    rules() {
      const fieldRequired = this.$i18n_t('Common.fieldRequired');
      return {
        required: function (v) {
          switch (typeof v) {
            case 'string':
              return v.length > 0 || fieldRequired;
            case 'number':
              return !isNaN(v) || fieldRequired;
            default:
              return v || fieldRequired;
          }
        },
      };
    },
  },
};
